import React from "react";
import injectGlobalStyle from "src/shared/util/inject-global-style";

const DesaTheme = React.lazy(() => import("./themes/Desa"));
const GodivaTheme = React.lazy(() => import("./themes/Godiva"));
const SamsungTheme = React.lazy(() => import("./themes/Samsung"));
const DemoTheme = React.lazy(() => import("./themes/Demo"));
const DevelopmentTheme = React.lazy(() => import("./themes/Development"));
const MarksSpencer = React.lazy(() => import("./themes/MarksSpencer"));
const UsPoloAssn = React.lazy(() => import("./themes/UsPoloAssn"));
const Workshop = React.lazy(() => import("./themes/Workshop"));
interface Props {
  theme: string;
  children: React.ReactNode;
}
interface ThemeMapper {
  [key: string]: typeof DesaTheme | typeof GodivaTheme | typeof SamsungTheme;
}
const themeMapper: ThemeMapper = {
  desa: DesaTheme,
  godiva: GodivaTheme,
  samsung: SamsungTheme,
  "demo.akinon.net": DemoTheme,
  "https://demo.akinon.net/": DemoTheme,
  development: DevelopmentTheme,
  "https://www.marksandspencer.com.tr": MarksSpencer,
  "tr.uspoloassn.com": UsPoloAssn,
  "https://workshop.akinoncloud.com": Workshop,
};

/**
 * Conditional loading of different shop styles
 */
const BrandStyleInjector = ({ theme, children }: Props) => {
  injectGlobalStyle();
  const shouldRenderTheme = theme in themeMapper;
  const Theme: any = shouldRenderTheme && themeMapper[theme];
  return (
    <>
      <React.Suspense fallback={() => null}>
        {shouldRenderTheme && <Theme />}
      </React.Suspense>
      {children}
    </>
  );
};

export default BrandStyleInjector;
